/* eslint-disable */
export const areaCodes = [
  {
    name_us: 'Albania',
    name_zh: '阿尔巴尼亚',
    name: 'AL',
    area_code: '355',
    time_diff: '-7',
  },
  {
    name_us: 'Algeria',
    name_zh: '阿尔及利亚',
    name: 'DZ',
    area_code: '213',
    time_diff: '-8',
  },
  {
    name_us: 'Afghanistan',
    name_zh: '阿富汗',
    name: 'AF',
    area_code: '93',
    time_diff: '0',
  },
  {
    name_us: 'Argentina',
    name_zh: '阿根廷',
    name: 'AR',
    area_code: '54',
    time_diff: '-11',
  },
  {
    name_us: 'United Arab Emirates',
    name_zh: '阿拉伯联合酋长国',
    name: 'AE',
    area_code: '971',
    time_diff: '-4',
  },
  {
    name_us: 'Oman',
    name_zh: '阿曼',
    name: 'OM',
    area_code: '968',
    time_diff: '-4',
  },
  {
    name_us: 'Azerbaijan',
    name_zh: '阿塞拜疆',
    name: 'AZ',
    area_code: '994',
    time_diff: '-5',
  },
  {
    name_us: 'Ascension',
    name_zh: '阿森松',
    name: ' ',
    area_code: '247',
    time_diff: '-8',
  },
  {
    name_us: 'Egypt',
    name_zh: '埃及',
    name: 'EG',
    area_code: '20',
    time_diff: '-6',
  },
  {
    name_us: 'Ethiopia',
    name_zh: '埃塞俄比亚',
    name: 'ET',
    area_code: '251',
    time_diff: '-5',
  },
  {
    name_us: 'Ireland',
    name_zh: '爱尔兰',
    name: 'IE',
    area_code: '353',
    time_diff: '-4.3',
  },
  {
    name_us: 'Estonia',
    name_zh: '爱沙尼亚',
    name: 'EE',
    area_code: '372',
    time_diff: '-5',
  },
  {
    name_us: 'Andorra',
    name_zh: '安道尔共和国',
    name: 'AD',
    area_code: '376',
    time_diff: '-8',
  },
  {
    name_us: 'Angola',
    name_zh: '安哥拉',
    name: 'AO',
    area_code: '244',
    time_diff: '-7',
  },
  {
    name_us: 'Anguilla',
    name_zh: '安圭拉岛',
    name: 'AI',
    area_code: '1264',
    time_diff: '-12',
  },
  {
    name_us: 'Antigua and Barbuda',
    name_zh: '安提瓜和巴布达',
    name: 'AG',
    area_code: '1268',
    time_diff: '-12',
  },
  {
    name_us: 'Austria',
    name_zh: '奥地利',
    name: 'AT',
    area_code: '43',
    time_diff: '-7',
  },
  {
    name_us: 'Australia',
    name_zh: '澳大利亚',
    name: 'AU',
    area_code: '61',
    time_diff: '+2',
  },
  {
    name_us: 'Macao',
    name_zh: '澳门',
    name: 'MO',
    area_code: '853',
    time_diff: '0',
  },
  {
    name_us: 'Barbados',
    name_zh: '巴巴多斯',
    name: 'BB',
    area_code: '1246',
    time_diff: '-12',
  },
  {
    name_us: 'Papua New Cuinea',
    name_zh: '巴布亚新几内亚',
    name: 'PG',
    area_code: '675',
    time_diff: '+2',
  },
  {
    name_us: 'Bahamas',
    name_zh: '巴哈马',
    name: 'BS',
    area_code: '1242',
    time_diff: '-13',
  },
  {
    name_us: 'Pakistan',
    name_zh: '巴基斯坦',
    name: 'PK',
    area_code: '92',
    time_diff: '-2.3',
  },
  {
    name_us: 'Paraguay',
    name_zh: '巴拉圭',
    name: 'PY',
    area_code: '595',
    time_diff: '-12',
  },
  {
    name_us: 'Bahrain',
    name_zh: '巴林',
    name: 'BH',
    area_code: '973',
    time_diff: '-5',
  },
  {
    name_us: 'Panama',
    name_zh: '巴拿马',
    name: 'PA',
    area_code: '507',
    time_diff: '-13',
  },
  {
    name_us: 'Brazil',
    name_zh: '巴西',
    name: 'BR',
    area_code: '55',
    time_diff: '-11',
  },
  {
    name_us: 'Belarus',
    name_zh: '白俄罗斯',
    name: 'BY',
    area_code: '375',
    time_diff: '-6',
  },
  {
    name_us: 'Bermuda Is.',
    name_zh: '百慕大群岛',
    name: 'BM',
    area_code: '1441',
    time_diff: '-12',
  },
  {
    name_us: 'Bulgaria',
    name_zh: '保加利亚',
    name: 'BG',
    area_code: '359',
    time_diff: '-6',
  },
  {
    name_us: 'Benin',
    name_zh: '贝宁',
    name: 'BJ',
    area_code: '229',
    time_diff: '-7',
  },
  {
    name_us: 'Belgium',
    name_zh: '比利时',
    name: 'BE',
    area_code: '32',
    time_diff: '-7',
  },
  {
    name_us: 'Iceland',
    name_zh: '冰岛',
    name: 'IS',
    area_code: '354',
    time_diff: '-9',
  },
  {
    name_us: 'Puerto Rico',
    name_zh: '波多黎各',
    name: 'PR',
    area_code: '1787',
    time_diff: '-12',
  },
  {
    name_us: 'Poland',
    name_zh: '波兰',
    name: 'PL',
    area_code: '48',
    time_diff: '-7',
  },
  {
    name_us: 'Bolivia',
    name_zh: '玻利维亚',
    name: 'BO',
    area_code: '591',
    time_diff: '-12',
  },
  {
    name_us: 'Belize',
    name_zh: '伯利兹',
    name: 'BZ',
    area_code: '501',
    time_diff: '-14',
  },
  {
    name_us: 'Botswana',
    name_zh: '博茨瓦纳',
    name: 'BW',
    area_code: '267',
    time_diff: '-6',
  },
  {
    name_us: 'Burkina-faso',
    name_zh: '布基纳法索',
    name: 'BF',
    area_code: '226',
    time_diff: '-8',
  },
  {
    name_us: 'Burundi',
    name_zh: '布隆迪',
    name: 'BI',
    area_code: '257',
    time_diff: '-6',
  },
  {
    name_us: 'North Korea',
    name_zh: '朝鲜',
    name: 'KP',
    area_code: '850',
    time_diff: '+1',
  },
  {
    name_us: 'Denmark',
    name_zh: '丹麦',
    name: 'DK',
    area_code: '45',
    time_diff: '-7',
  },
  {
    name_us: 'Germany',
    name_zh: '德国',
    name: 'DE',
    area_code: '49',
    time_diff: '-7',
  },
  {
    name_us: 'Samoa Eastern',
    name_zh: '东萨摩亚(美)',
    name: ' ',
    area_code: '684',
    time_diff: '-19',
  },
  {
    name_us: 'Togo',
    name_zh: '多哥',
    name: 'TG',
    area_code: '228',
    time_diff: '-8',
  },
  {
    name_us: 'Dominica Rep.',
    name_zh: '多米尼加共和国',
    name: 'DO',
    area_code: '1890',
    time_diff: '-13',
  },
  {
    name_us: 'Russia',
    name_zh: '俄罗斯',
    name: 'RU',
    area_code: '7',
    time_diff: '-5',
  },
  {
    name_us: 'Ecuador',
    name_zh: '厄瓜多尔',
    name: 'EC',
    area_code: '593',
    time_diff: '-13',
  },
  {
    name_us: 'France',
    name_zh: '法国',
    name: 'FR',
    area_code: '33',
    time_diff: '-8',
  },
  {
    name_us: 'French Polynesia',
    name_zh: '法属玻利尼西亚',
    name: 'PF',
    area_code: '689',
    time_diff: '+3',
  },
  {
    name_us: 'French Guiana',
    name_zh: '法属圭亚那',
    name: 'GF',
    area_code: '594',
    time_diff: '-12',
  },
  {
    name_us: 'Philippines',
    name_zh: '菲律宾',
    name: 'PH',
    area_code: '63',
    time_diff: '0',
  },
  {
    name_us: 'Fiji',
    name_zh: '斐济',
    name: 'FJ',
    area_code: '679',
    time_diff: '+4',
  },
  {
    name_us: 'Finland',
    name_zh: '芬兰',
    name: 'FI',
    area_code: '358',
    time_diff: '-6',
  },
  {
    name_us: 'Gambia',
    name_zh: '冈比亚',
    name: 'GM',
    area_code: '220',
    time_diff: '-8',
  },
  {
    name_us: 'Congo',
    name_zh: '刚果',
    name: 'CG',
    area_code: '242',
    time_diff: '-7',
  },
  {
    name_us: 'Colombia',
    name_zh: '哥伦比亚',
    name: 'CO',
    area_code: '57',
    time_diff: '0',
  },
  {
    name_us: 'Costa Rica',
    name_zh: '哥斯达黎加',
    name: 'CR',
    area_code: '506',
    time_diff: '-14',
  },
  {
    name_us: 'Grenada',
    name_zh: '格林纳达',
    name: 'GD',
    area_code: '1809',
    time_diff: '-14',
  },
  {
    name_us: 'Georgia',
    name_zh: '格鲁吉亚',
    name: 'GE',
    area_code: '995',
    time_diff: '0',
  },
  {
    name_us: 'Cuba',
    name_zh: '古巴',
    name: 'CU',
    area_code: '53',
    time_diff: '-13',
  },
  {
    name_us: 'Guam',
    name_zh: '关岛',
    name: 'GU',
    area_code: '1671',
    time_diff: '+2',
  },
  {
    name_us: 'Guyana',
    name_zh: '圭亚那',
    name: 'GY',
    area_code: '592',
    time_diff: '-11',
  },
  {
    name_us: 'Kazakstan',
    name_zh: '哈萨克斯坦',
    name: 'KZ',
    area_code: '327',
    time_diff: '-5',
  },
  {
    name_us: 'Haiti',
    name_zh: '海地',
    name: 'HT',
    area_code: '509',
    time_diff: '-13',
  },
  {
    name_us: 'Korea',
    name_zh: '韩国',
    name: 'KR',
    area_code: '82',
    time_diff: '+1',
  },
  {
    name_us: 'Netherlands',
    name_zh: '荷兰',
    name: 'NL',
    area_code: '31',
    time_diff: '-7',
  },
  {
    name_us: 'Netheriands Antilles',
    name_zh: '荷属安的列斯',
    name: ' ',
    area_code: '599',
    time_diff: '-12',
  },
  {
    name_us: 'Honduras',
    name_zh: '洪都拉斯',
    name: 'HN',
    area_code: '504',
    time_diff: '-14',
  },
  {
    name_us: 'Djibouti',
    name_zh: '吉布提',
    name: 'DJ',
    area_code: '253',
    time_diff: '-5',
  },
  {
    name_us: 'Kyrgyzstan',
    name_zh: '吉尔吉斯坦',
    name: 'KG',
    area_code: '331',
    time_diff: '-5',
  },
  {
    name_us: 'Guinea',
    name_zh: '几内亚',
    name: 'GN',
    area_code: '224',
    time_diff: '-8',
  },
  {
    name_us: 'Canada',
    name_zh: '加拿大',
    name: 'CA',
    area_code: '1',
    time_diff: '-13',
  },
  {
    name_us: 'Ghana',
    name_zh: '加纳',
    name: 'GH',
    area_code: '233',
    time_diff: '-8',
  },
  {
    name_us: 'Gabon',
    name_zh: '加蓬',
    name: 'GA',
    area_code: '241',
    time_diff: '-7',
  },
  {
    name_us: 'Kampuchea (Cambodia )',
    name_zh: '柬埔寨',
    name: 'KH',
    area_code: '855',
    time_diff: '-1',
  },
  {
    name_us: 'Czech Republic',
    name_zh: '捷克',
    name: 'CZ',
    area_code: '420',
    time_diff: '-7',
  },
  {
    name_us: 'Zimbabwe',
    name_zh: '津巴布韦',
    name: 'ZW',
    area_code: '263',
    time_diff: '-6',
  },
  {
    name_us: 'Cameroon',
    name_zh: '喀麦隆',
    name: 'CM',
    area_code: '237',
    time_diff: '-7',
  },
  {
    name_us: 'Qatar',
    name_zh: '卡塔尔',
    name: 'QA',
    area_code: '974',
    time_diff: '-5',
  },
  {
    name_us: 'Cayman Is.',
    name_zh: '开曼群岛',
    name: ' ',
    area_code: '1345',
    time_diff: '-13',
  },
  {
    name_us: 'Ivory Coast',
    name_zh: '科特迪瓦',
    name: ' ',
    area_code: '225',
    time_diff: '-6',
  },
  {
    name_us: 'Kuwait',
    name_zh: '科威特',
    name: 'KW',
    area_code: '965',
    time_diff: '-5',
  },
  {
    name_us: 'Kenya',
    name_zh: '肯尼亚',
    name: 'KE',
    area_code: '254',
    time_diff: '-5',
  },
  {
    name_us: 'Cook Is.',
    name_zh: '库克群岛',
    name: 'CK',
    area_code: '682',
    time_diff: '-18.3',
  },
  {
    name_us: 'Latvia',
    name_zh: '拉脱维亚',
    name: 'LV',
    area_code: '371',
    time_diff: '-5',
  },
  {
    name_us: 'Lesotho',
    name_zh: '莱索托',
    name: 'LS',
    area_code: '266',
    time_diff: '-6',
  },
  {
    name_us: 'Laos',
    name_zh: '老挝',
    name: 'LA',
    area_code: '856',
    time_diff: '-1',
  },
  {
    name_us: 'Lebanon',
    name_zh: '黎巴嫩',
    name: 'LB',
    area_code: '961',
    time_diff: '-6',
  },
  {
    name_us: 'Lithuania',
    name_zh: '立陶宛',
    name: 'LT',
    area_code: '370',
    time_diff: '-5',
  },
  {
    name_us: 'Liberia',
    name_zh: '利比里亚',
    name: 'LR',
    area_code: '231',
    time_diff: '-8',
  },
  {
    name_us: 'Libya',
    name_zh: '利比亚',
    name: 'LY',
    area_code: '218',
    time_diff: '-6',
  },
  {
    name_us: 'Liechtenstein',
    name_zh: '列支敦士登',
    name: 'LI',
    area_code: '423',
    time_diff: '-7',
  },
  {
    name_us: 'Reunion',
    name_zh: '留尼旺',
    name: ' ',
    area_code: '262',
    time_diff: '-4',
  },
  {
    name_us: 'Luxembourg',
    name_zh: '卢森堡',
    name: 'LU',
    area_code: '352',
    time_diff: '-7',
  },
  {
    name_us: 'Romania',
    name_zh: '罗马尼亚',
    name: 'RO',
    area_code: '40',
    time_diff: '-6',
  },
  {
    name_us: 'Madagascar',
    name_zh: '马达加斯加',
    name: 'MG',
    area_code: '261',
    time_diff: '-5',
  },
  {
    name_us: 'Maldives',
    name_zh: '马尔代夫',
    name: 'MV',
    area_code: '960',
    time_diff: '-7',
  },
  {
    name_us: 'Malta',
    name_zh: '马耳他',
    name: 'MT',
    area_code: '356',
    time_diff: '-7',
  },
  {
    name_us: 'Malawi',
    name_zh: '马拉维',
    name: 'MW',
    area_code: '265',
    time_diff: '-6',
  },
  {
    name_us: 'Malaysia',
    name_zh: '马来西亚',
    name: 'MY',
    area_code: '60',
    time_diff: '-0.5',
  },
  {
    name_us: 'Mali',
    name_zh: '马里',
    name: 'ML',
    area_code: '223',
    time_diff: '-8',
  },
  {
    name_us: 'Mariana Is',
    name_zh: '马里亚那群岛',
    name: ' ',
    area_code: '1670',
    time_diff: '+1',
  },
  {
    name_us: 'Martinique',
    name_zh: '马提尼克',
    name: ' ',
    area_code: '596',
    time_diff: '-12',
  },
  {
    name_us: 'Mauritius',
    name_zh: '毛里求斯',
    name: 'MU',
    area_code: '230',
    time_diff: '-4',
  },
  {
    name_us: 'United States of America',
    name_zh: '美国',
    name: 'US',
    area_code: '1',
    time_diff: '-13',
  },
  {
    name_us: 'Mongolia',
    name_zh: '蒙古',
    name: 'MN',
    area_code: '976',
    time_diff: '0',
  },
  {
    name_us: 'Montserrat Is',
    name_zh: '蒙特塞拉特岛',
    name: 'MS',
    area_code: '1664',
    time_diff: '-12',
  },
  {
    name_us: 'Bangladesh',
    name_zh: '孟加拉国',
    name: 'BD',
    area_code: '880',
    time_diff: '-2',
  },
  {
    name_us: 'Peru',
    name_zh: '秘鲁',
    name: 'PE',
    area_code: '51',
    time_diff: '-13',
  },
  {
    name_us: 'Burma',
    name_zh: '缅甸',
    name: 'MM',
    area_code: '95',
    time_diff: '-1.3',
  },
  {
    name_us: 'Moldova Republic of',
    name_zh: '摩尔多瓦',
    name: 'MD',
    area_code: '373',
    time_diff: '-5',
  },
  {
    name_us: 'Morocco',
    name_zh: '摩洛哥',
    name: 'MA',
    area_code: '212',
    time_diff: '-6',
  },
  {
    name_us: 'Monaco',
    name_zh: '摩纳哥',
    name: 'MC',
    area_code: '377',
    time_diff: '-7',
  },
  {
    name_us: 'Mozambique',
    name_zh: '莫桑比克',
    name: 'MZ',
    area_code: '258',
    time_diff: '-6',
  },
  {
    name_us: 'Mexico',
    name_zh: '墨西哥',
    name: 'MX',
    area_code: '52',
    time_diff: '-15',
  },
  {
    name_us: 'Namibia',
    name_zh: '纳米比亚',
    name: 'NA',
    area_code: '264',
    time_diff: '-7',
  },
  {
    name_us: 'South Africa',
    name_zh: '南非',
    name: 'ZA',
    area_code: '27',
    time_diff: '-6',
  },
  {
    name_us: 'Yugoslavia',
    name_zh: '南斯拉夫',
    name: 'YU',
    area_code: '381',
    time_diff: '-7',
  },
  {
    name_us: 'Nauru',
    name_zh: '瑙鲁',
    name: 'NR',
    area_code: '674',
    time_diff: '+4',
  },
  {
    name_us: 'Nicaragua',
    name_zh: '尼加拉瓜',
    name: 'NI',
    area_code: '505',
    time_diff: '-14',
  },
  {
    name_us: 'Nepal',
    name_zh: '尼泊尔',
    name: 'NP',
    area_code: '977',
    time_diff: '-2.3',
  },
  {
    name_us: 'Niger',
    name_zh: '尼日尔',
    name: 'NE',
    area_code: '227',
    time_diff: '-8',
  },
  {
    name_us: 'Nigeria',
    name_zh: '尼日利亚',
    name: 'NG',
    area_code: '234',
    time_diff: '-7',
  },
  {
    name_us: 'Norway',
    name_zh: '挪威',
    name: 'NO',
    area_code: '47',
    time_diff: '-7',
  },
  {
    name_us: 'Portugal',
    name_zh: '葡萄牙',
    name: 'PT',
    area_code: '351',
    time_diff: '-8',
  },
  {
    name_us: 'Japan',
    name_zh: '日本',
    name: 'JP',
    area_code: '81',
    time_diff: '+1',
  },
  {
    name_us: 'Sweden',
    name_zh: '瑞典',
    name: 'SE',
    area_code: '46',
    time_diff: '-7',
  },
  {
    name_us: 'Switzerland',
    name_zh: '瑞士',
    name: 'CH',
    area_code: '41',
    time_diff: '-7',
  },
  {
    name_us: 'EI Salvador',
    name_zh: '萨尔瓦多',
    name: 'SV',
    area_code: '503',
    time_diff: '-14',
  },
  {
    name_us: 'Sierra Leone',
    name_zh: '塞拉利昂',
    name: 'SL',
    area_code: '232',
    time_diff: '-8',
  },
  {
    name_us: 'Senegal',
    name_zh: '塞内加尔',
    name: 'SN',
    area_code: '221',
    time_diff: '-8',
  },
  {
    name_us: 'Cyprus',
    name_zh: '塞浦路斯',
    name: 'CY',
    area_code: '357',
    time_diff: '-6',
  },
  {
    name_us: 'Seychelles',
    name_zh: '塞舌尔',
    name: 'SC',
    area_code: '248',
    time_diff: '-4',
  },
  {
    name_us: 'Saudi Arabia',
    name_zh: '沙特阿拉伯',
    name: 'SA',
    area_code: '966',
    time_diff: '-5',
  },
  {
    name_us: 'Sao Tome and Principe',
    name_zh: '圣多美和普林西比',
    name: 'ST',
    area_code: '239',
    time_diff: '-8',
  },
  {
    name_us: 'Saint Lueia',
    name_zh: '圣卢西亚',
    name: 'LC',
    area_code: '1758',
    time_diff: '-12',
  },
  {
    name_us: 'San Marino',
    name_zh: '圣马力诺',
    name: 'SM',
    area_code: '378',
    time_diff: '-7',
  },
  {
    name_us: 'St.Vincent',
    name_zh: '圣文森特',
    name: 'VC',
    area_code: '1784',
    time_diff: '-12',
  },
  {
    name_us: 'Sri Lanka',
    name_zh: '斯里兰卡',
    name: 'LK',
    area_code: '94',
    time_diff: '0',
  },
  {
    name_us: 'Slovakia',
    name_zh: '斯洛伐克',
    name: 'SK',
    area_code: '421',
    time_diff: '-7',
  },
  {
    name_us: 'Slovenia',
    name_zh: '斯洛文尼亚',
    name: 'SI',
    area_code: '386',
    time_diff: '-7',
  },
  {
    name_us: 'Swaziland',
    name_zh: '斯威士兰',
    name: 'SZ',
    area_code: '268',
    time_diff: '-6',
  },
  {
    name_us: 'Sudan',
    name_zh: '苏丹',
    name: 'SD',
    area_code: '249',
    time_diff: '-6',
  },
  {
    name_us: 'Suriname',
    name_zh: '苏里南',
    name: 'SR',
    area_code: '597',
    time_diff: '-11.3',
  },
  {
    name_us: 'Solomon Is',
    name_zh: '所罗门群岛',
    name: 'SB',
    area_code: '677',
    time_diff: '+3',
  },
  {
    name_us: 'Somali',
    name_zh: '索马里',
    name: 'SO',
    area_code: '252',
    time_diff: '-5',
  },
  {
    name_us: 'Tajikstan',
    name_zh: '塔吉克斯坦',
    name: 'TJ',
    area_code: '992',
    time_diff: '-5',
  },
  {
    name_us: 'Taiwan',
    name_zh: '台湾省',
    name: 'TW',
    area_code: '886',
    time_diff: '0',
  },
  {
    name_us: 'Thailand',
    name_zh: '泰国',
    name: 'TH',
    area_code: '66',
    time_diff: '-1',
  },
  {
    name_us: 'Tanzania',
    name_zh: '坦桑尼亚',
    name: 'TZ',
    area_code: '255',
    time_diff: '-5',
  },
  {
    name_us: 'Tonga',
    name_zh: '汤加',
    name: 'TO',
    area_code: '676',
    time_diff: '+4',
  },
  {
    name_us: 'Trinidad and Tobago',
    name_zh: '特立尼达和多巴哥',
    name: 'TT',
    area_code: '1809',
    time_diff: '-12',
  },
  {
    name_us: 'Tunisia',
    name_zh: '突尼斯',
    name: 'TN',
    area_code: '216',
    time_diff: '-7',
  },
  {
    name_us: 'Turkey',
    name_zh: '土耳其',
    name: 'TR',
    area_code: '90',
    time_diff: '-6',
  },
  {
    name_us: 'Turkmenistan',
    name_zh: '土库曼斯坦',
    name: 'TM',
    area_code: '993',
    time_diff: '-5',
  },
  {
    name_us: 'Guatemala',
    name_zh: '危地马拉',
    name: 'GT',
    area_code: '502',
    time_diff: '-14',
  },
  {
    name_us: 'Venezuela',
    name_zh: '委内瑞拉',
    name: 'VE',
    area_code: '58',
    time_diff: '-12.3',
  },
  {
    name_us: 'Brunei',
    name_zh: '文莱',
    name: 'BN',
    area_code: '673',
    time_diff: '0',
  },
  {
    name_us: 'Uganda',
    name_zh: '乌干达',
    name: 'UG',
    area_code: '256',
    time_diff: '-5',
  },
  {
    name_us: 'Ukraine',
    name_zh: '乌克兰',
    name: 'UA',
    area_code: '380',
    time_diff: '-5',
  },
  {
    name_us: 'Uruguay',
    name_zh: '乌拉圭',
    name: 'UY',
    area_code: '598',
    time_diff: '-10.3',
  },
  {
    name_us: 'Uzbekistan',
    name_zh: '乌兹别克斯坦',
    name: 'UZ',
    area_code: '233',
    time_diff: '-5',
  },
  {
    name_us: 'Spain',
    name_zh: '西班牙',
    name: 'ES',
    area_code: '34',
    time_diff: '-8',
  },
  {
    name_us: 'Samoa Western',
    name_zh: '西萨摩亚',
    name: ' ',
    area_code: '685',
    time_diff: '-19',
  },
  {
    name_us: 'Greece',
    name_zh: '希腊',
    name: 'GR',
    area_code: '30',
    time_diff: '-6',
  },
  {
    name_us: 'Hongkong',
    name_zh: '香港',
    name: 'HK',
    area_code: '852',
    time_diff: '0',
  },
  {
    name_us: 'Singapore',
    name_zh: '新加坡',
    name: 'SG',
    area_code: '65',
    time_diff: '+0.3',
  },
  {
    name_us: 'New Zealand',
    name_zh: '新西兰',
    name: 'NZ',
    area_code: '64',
    time_diff: '+4',
  },
  {
    name_us: 'Hungary',
    name_zh: '匈牙利',
    name: 'HU',
    area_code: '36',
    time_diff: '-7',
  },
  {
    name_us: 'Syria',
    name_zh: '叙利亚',
    name: 'SY',
    area_code: '963',
    time_diff: '-6',
  },
  {
    name_us: 'Jamaica',
    name_zh: '牙买加',
    name: 'JM',
    area_code: '1876',
    time_diff: '-12',
  },
  {
    name_us: 'Armenia',
    name_zh: '亚美尼亚',
    name: 'AM',
    area_code: '374',
    time_diff: '-6',
  },
  {
    name_us: 'Yemen',
    name_zh: '也门',
    name: 'YE',
    area_code: '967',
    time_diff: '-5',
  },
  {
    name_us: 'Iraq',
    name_zh: '伊拉克',
    name: 'IQ',
    area_code: '964',
    time_diff: '-5',
  },
  {
    name_us: 'Iran',
    name_zh: '伊朗',
    name: 'IR',
    area_code: '98',
    time_diff: '-4.3',
  },
  {
    name_us: 'Israel',
    name_zh: '以色列',
    name: 'IL',
    area_code: '972',
    time_diff: '-6',
  },
  {
    name_us: 'Italy',
    name_zh: '意大利',
    name: 'IT',
    area_code: '39',
    time_diff: '-7',
  },
  {
    name_us: 'India',
    name_zh: '印度',
    name: 'IN',
    area_code: '91',
    time_diff: '-2.3',
  },
  {
    name_us: 'Indonesia',
    name_zh: '印度尼西亚',
    name: 'ID',
    area_code: '62',
    time_diff: '-0.3',
  },
  {
    name_us: 'United Kiongdom',
    name_zh: '英国',
    name: 'GB',
    area_code: '44',
    time_diff: '-8',
  },
  {
    name_us: 'Jordan',
    name_zh: '约旦',
    name: 'JO',
    area_code: '962',
    time_diff: '-6',
  },
  {
    name_us: 'Vietnam',
    name_zh: '越南',
    name: 'VN',
    area_code: '84',
    time_diff: '-1',
  },
  {
    name_us: 'Zambia',
    name_zh: '赞比亚',
    name: 'ZM',
    area_code: '260',
    time_diff: '-6',
  },
  {
    name_us: 'Zaire',
    name_zh: '扎伊尔',
    name: 'ZR',
    area_code: '243',
    time_diff: '-7',
  },
  {
    name_us: 'Chad',
    name_zh: '乍得',
    name: 'TD',
    area_code: '235',
    time_diff: '-7',
  },
  {
    name_us: 'Gibraltar',
    name_zh: '直布罗陀',
    name: 'GI',
    area_code: '350',
    time_diff: '-8',
  },
  {
    name_us: 'Chile',
    name_zh: '智利',
    name: 'CL',
    area_code: '56',
    time_diff: '-13',
  },
  {
    name_us: 'Central African Republic',
    name_zh: '中非共和国',
    name: 'CF',
    area_code: '236',
    time_diff: '-7',
  },
  {
    name_us: 'China',
    name_zh: '中国',
    name: 'CN',
    area_code: '86',
    time_diff: '0',
  },
];